import { Box, Flex, FlexProps } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { rem } from 'polished';
import { gradients } from '../../theme/colors';

const load = keyframes`
  0% {
    transform: scale(0);
  }
  30% {
    transform: scale(1);
  }
  60%, 100% {
    transform: scale(0);
  }
`;

export const MediaLoader = ({ color = gradients.sunnySkyConic, ...props }: FlexProps) => (
  <Flex gap="space.4" {...props}>
    <Box
      animation={`${load} infinite 1.5s linear 0s`}
      boxSize={rem(16)}
      bg={color}
      rounded="full"
    />
    <Box
      transform="scale(0)"
      animation={`${load} infinite 1.5s linear 0.25s`}
      boxSize={rem(16)}
      bg={color}
      rounded="full"
    />
    <Box
      transform="scale(0)"
      animation={`${load} infinite 1.5s linear 0.5s`}
      boxSize={rem(16)}
      bg={color}
      rounded="full"
    />
  </Flex>
);
